/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Zapomněli jste na položku? <a class="underline" href="${i.link}">Upravte svůj košík</a>`
};

const da_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Har du glemt en vare? <a class="underline" href="${i.link}">Rediger din kurv</a>`
};

const de_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Haben Sie einen Artikel vergessen? <a class="underline" href="${i.link}">Warenkorb bearbeiten</a>`
};

const en_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Forgot an item? <a class="underline" href="${i.link}">Edit your cart</a>`
};

const es_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `¿Olvidaste un artículo? <a class="underline" href="${i.link}">Editar tu carrito</a>`
};

const fr_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Vous avez oublié un article ? <a class="underline" href="${i.link}">Modifier votre panier</a>`
};

const hu_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Elfelejtetted valamin? <a class="underline" href="${i.link}">Módosítsd a kosárod</a>`
};

const it_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Hai dimenticato un articolo? <a class="underline" href="${i.link}">Modifica il tuo carrello</a>`
};

const nl_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Ben je een artikel vergeten? <a class="underline" href="${i.link}">Winkelwagen aanpassen</a>`
};

const pl_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Zapomniałeś produktu? <a class="underline" href="${i.link}">Edytuj koszyk</a>`
};

const pt_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Esqueceu um item? <a class="underline" href="${i.link}">Editar seu carrinho</a>`
};

const sv_forgot_item_edit_cart = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Glömt en vara? <a class="underline" href="${i.link}">Redigera din kundvagn</a>`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ link: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const forgot_item_edit_cart = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.forgot_item_edit_cart(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("forgot_item_edit_cart", locale)
	if (locale === "cs") return cs_forgot_item_edit_cart(inputs)
	if (locale === "da") return da_forgot_item_edit_cart(inputs)
	if (locale === "de") return de_forgot_item_edit_cart(inputs)
	if (locale === "en") return en_forgot_item_edit_cart(inputs)
	if (locale === "es") return es_forgot_item_edit_cart(inputs)
	if (locale === "fr") return fr_forgot_item_edit_cart(inputs)
	if (locale === "hu") return hu_forgot_item_edit_cart(inputs)
	if (locale === "it") return it_forgot_item_edit_cart(inputs)
	if (locale === "nl") return nl_forgot_item_edit_cart(inputs)
	if (locale === "pl") return pl_forgot_item_edit_cart(inputs)
	if (locale === "pt") return pt_forgot_item_edit_cart(inputs)
	return sv_forgot_item_edit_cart(inputs)
};